import { createSlice } from "@reduxjs/toolkit";
import { buildVocabMap } from "@/util/vocab";
import { loadCachedVocabulary } from "@/util/vocabularyCache";
import { fetchVocabulary } from "@/apis/config/vocabularyApi";

// Site-specific label renames from the Vocabulary table. Starts from the
// cached copy so labels render immediately, then is replaced by the fresh
// rows fetched on each page load. Empty when neither exists, so every label
// shows its default text.
const cachedRows = loadCachedVocabulary();

const initialState = {
  list: cachedRows,
  // Built once per data change so label lookups during render are plain reads.
  map: buildVocabMap(cachedRows),
};

const slice = createSlice({
  name: "vocabulary",
  initialState,
  reducers: {
    setVocabulary(state, action) {
      state.list = Array.isArray(action.payload) ? action.payload : [];
      state.map = buildVocabMap(state.list);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchVocabulary.fulfilled, (state, action) => {
      state.list = action.payload;
      state.map = buildVocabMap(state.list);
    });
  },
});

export const { setVocabulary } = slice.actions;
export default slice.reducer;
